export default __webpack_public_path__ + "static/media/audi.72d66c53.svg";